import { render } from "./Collection.vue?vue&type=template&id=52014506&scoped=true&ts=true"
import script from "./Collection.vue?vue&type=script&lang=ts"
export * from "./Collection.vue?vue&type=script&lang=ts"

import "./Collection.vue?vue&type=style&index=0&id=52014506&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52014506"]])

export default __exports__